var map = {
	"./clickHigh.wav": 7175,
	"./clickLow.wav": 3386,
	"./clickLow_2.wav": 9746,
	"./loop.mp3": 9791,
	"./loop.wav": 4230,
	"./success.wav": 9697,
	"./success_2.wav": 2439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3323;